import React from 'react'
import { useSelector, useDispatch } from 'react-redux'

// Redux slices
import { updateObjectData, doObjectAction } from './objectSlice';

// SemanticUI components
import { CardMeta, CardHeader, CardGroup, CardContent, Card, Container, Grid, GridRow, GridColumn, Image, FormCheckbox, FormInput, Button, Icon, Form, Header, HeaderContent } from 'semantic-ui-react'

// Styles
import './object.css';




/**
 * 
 * @param {object} transfer 
 * @returns 
 */
const Max2TransferCard = ({transfer}) => {
  return (
    <Card fluid key={transfer.DestinationAirport} style={{ maxWidth: '399px' }}>
      <CardContent style={{background: '#f5f5f5'}}>
        <CardHeader style={{float: 'left'}}>{transfer.DestinationAirport}</CardHeader>
        <CardMeta style={{float: 'left', marginTop: '-3px', marginLeft: '10px'}}>{transfer.DestinationName}</CardMeta>
        <Grid style={{clear: 'both'}}>
          <GridRow className='media_ro_row'><GridColumn width={7} className='media_ro_label' textAlign='right'>Destinationscode: </GridColumn><GridColumn width={9}>{transfer.DestinationCode}</GridColumn></GridRow>
          <GridRow className='media_ro_row'><GridColumn width={7} className='media_ro_label' textAlign='right'>Bustransfer: </GridColumn><GridColumn width={9}>{transfer.BusTransfer}</GridColumn></GridRow>
          <GridRow className='media_ro_row'><GridColumn width={7} className='media_ro_label' textAlign='right'>Taxitransfer: </GridColumn><GridColumn width={9}>{transfer.TaxiTransfer}</GridColumn></GridRow>
          <GridRow className='media_ro_row'><GridColumn width={7} className='media_ro_label' textAlign='right'>Transfermail: </GridColumn><GridColumn width={9}>{transfer.TransferMail1}</GridColumn></GridRow>
          <GridRow className='media_ro_row'><GridColumn width={7} className='media_ro_label' textAlign='right'>zum Store übermitteln: </GridColumn><GridColumn width={9}>{transfer.SubmitToStore && (<Image size='mini' src='resources/icons/WE_correct_icon_bestaetigen.svg' title='zum Store übermitteln' style={{width: '20px', margin: '0px'}} />)}</GridColumn></GridRow>
        </Grid>
      </CardContent>
    </Card>
  );
}



/**
 * 
 * @param {object} transfer 
 * @param {integer} transferIndex
 * @returns 
 */
const Max2TransferCardEdit = ({transfer, transferIndex}) => {
  const dispatch  = useDispatch();


  /**
   * 
   * @param {integer} index 
   * @param {string} value 
   */
  const handleInputChange = (index, key, value) => {
    dispatch(updateObjectData({section: 'Transfers', index: index, key: key, value: value}))
  };


  return (
    <Card fluid key={transferIndex} style={{ maxWidth: '399px' }}>
      <CardContent style={{background: '#f5f5f5'}}>
        <CardHeader style={{float: 'left'}}>{transfer.DestinationAirport}</CardHeader>
        <CardMeta style={{float: 'left', marginTop: '-3px', marginLeft: '10px'}}>[ Destination-Name ]</CardMeta>
        <Form>
          <Grid style={{clear: 'both'}}>
            <GridRow className='media_ro_row'>
              <GridColumn width={7} className='media_ro_label' textAlign='right'>Destination Airport: </GridColumn>
              <GridColumn width={9}><FormInput placeholder='Destinationscode' value={transfer.DestinationAirport} onChange={(e) => handleInputChange(transferIndex, 'DestinationAirport', e.target.value)} /></GridColumn>
            </GridRow>
            <GridRow className='media_ro_row'>
              <GridColumn width={7} className='media_ro_label' textAlign='right'>Destination Code: </GridColumn>
              <GridColumn width={9}><FormInput placeholder='Destinationscode' value={transfer.DestinationCode} onChange={(e) => handleInputChange(transferIndex, 'DestinationCode', e.target.value)} /></GridColumn>
            </GridRow>
            <GridRow className='media_ro_row'>
              <GridColumn width={7} className='media_ro_label' textAlign='right'>Bustransfer: </GridColumn>
              <GridColumn width={9}><FormInput placeholder='Bustransfer' value={transfer.BusTransfer} onChange={(e) => handleInputChange(transferIndex, 'BusTransfer', e.target.value)} /></GridColumn>
              </GridRow>
            <GridRow className='media_ro_row'>
              <GridColumn width={7} className='media_ro_label' textAlign='right'>Taxitransfer: </GridColumn>
              <GridColumn width={9}><FormInput placeholder='Taxitransfer' value={transfer.TaxiTransfer} onChange={(e) => handleInputChange(transferIndex, 'TaxiTransfer', e.target.value)} /></GridColumn>
              </GridRow>
            <GridRow className='media_ro_row'>
              <GridColumn width={7} className='media_ro_label' textAlign='right'>Transfermail: </GridColumn>
              <GridColumn width={9}><FormInput placeholder='E-Mail-Adresse' value={transfer.TransferMail1} onChange={(e) => handleInputChange(transferIndex, 'TransferMail1', e.target.value)} /></GridColumn>
              </GridRow>
            <GridRow className='media_ro_row'>
              <GridColumn width={7} className='media_ro_label' textAlign='right'>zum Store übermitteln: </GridColumn>
              <GridColumn width={9}><FormCheckbox toggle checked={transfer.SubmitToStore} onChange={(e) => handleInputChange(transferIndex, 'SubmitToStore', !transfer.SubmitToStore)} /></GridColumn>
            </GridRow>
          </Grid>
        </Form>
      </CardContent>
      <CardContent style={{background: '#f5f5f5'}}>
        <Button basic circular icon floated='right' title="Transfer löschen">
          <Icon name='trash' onClick={() => dispatch(doObjectAction({target: 'DeleteTransfer', index:transferIndex}))} />
        </Button>
      </CardContent>
    </Card>
  );
}





const Max2Transfers = () => {
  // local State

  // global State
  const dispatch  = useDispatch();
  const editMode  = useSelector((state) => state.object.sections.Transfers.edit);
  const object    = useSelector((state) => state.object.data);



  


  const cards = object.Transfers.map((transfer, transferIndex) => {
    if (editMode) {
      return <Max2TransferCardEdit transfer={transfer} transferIndex={transferIndex} />;
    }
    return <Max2TransferCard transfer={transfer} />;
  });

  if (editMode) {
    return (
      <Container style={{width: '99%'}}>
        <CardGroup style={{ marginBottom: '10px' }}>
          {cards}
        </CardGroup>
        <Button basic circular icon labelPosition='left' onClick={() => dispatch(doObjectAction({target: 'AddTransfer'}))}>
            <Icon name='add' />
            Transfer hinzufügen
        </Button>
      </Container>
    );
  }

  return (
    <Container style={{width: '99%'}}>
      {object.Transfers.length > 0 
        ? <><CardGroup>{cards}</CardGroup></>
        : <><Header as='h4' textAlign='center'><Icon name='times circle outline' /><HeaderContent>Keine Einträge vorhanden</HeaderContent></Header><br /></>
      }
    </Container>
  );
}

export default  Max2Transfers;
